if (!customElements.get('purchase-options-supply')) {
  class PurchaseOptionsSupply extends HTMLElement {
    constructor() {
      super();
      this.syncForm = this.syncForm.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this._pack = null;
      this._subscribe = null;
    }

    connectedCallback() {
      this.formId = 'product-form-' + this.dataset.section;
      this.syncForm();
      this.addEventListener('change', this.syncForm);
      /* Capture auf document läuft vor dem submit-Listener von product-form.js,
         der FormData sofort ausliest. Gilt auch für die Sticky-ATC-Form. */
      document.addEventListener('submit', this.handleSubmit, true);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.syncForm);
      document.removeEventListener('submit', this.handleSubmit, true);
    }

    mainForm() {
      return document.getElementById(this.formId);
    }

    selection() {
      var supply = this.querySelector('.pos__supply:checked');
      if (!supply) return null;
      var card = supply.closest('.pos__card');
      var mode = card.querySelector('.pos__mode-input:checked');
      var subscribe = !!(mode && mode.value === 'subscribe');
      return {
        pack: supply.value,
        packQty: card.getAttribute('data-qty') || '1',
        subscribe: subscribe,
        planId: subscribe ? (card.getAttribute('data-plan-id') || '') : ''
      };
    }

    field(form, name) {
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      return input;
    }

    setQty(form, qty) {
      var next = String(qty);
      var inputs = form.querySelectorAll('input[name="quantity"]');
      if (!inputs.length) inputs = [this.field(form, 'quantity')];
      Array.prototype.forEach.call(inputs, function (input) {
        input.value = next;
        input.setAttribute('value', next);
        var host = input.closest('quantity-input');
        if (host) host.currentQty = next;
      });
    }

    writeForm(form, sel, qty) {
      this.setQty(form, qty);
      this.field(form, 'selling_plan').value = sel.planId;
      this.field(form, 'properties[_supply]').value = sel.pack;
    }

    syncForm() {
      var form = this.mainForm();
      var sel = this.selection();
      if (!form || !sel) return;

      var packChanged = this._pack !== sel.pack;
      var modeChanged = this._subscribe !== sel.subscribe;
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? qtyInput.value : sel.packQty;
      if (sel.subscribe || packChanged || modeChanged || this._pack == null) {
        qty = sel.packQty;
      }

      this._pack = sel.pack;
      this._subscribe = sel.subscribe;
      this.classList.toggle('pos--onetime', !sel.subscribe);
      this.writeForm(form, sel, qty);
    }

    handleSubmit(evt) {
      var form = evt.target;
      if (!form || (form.id !== this.formId && form.id !== this.formId + '-sticky')) return;
      var sel = this.selection();
      if (!sel) return;

      /* Abo: Menge fest. Einmalkauf: Menge der Haupt-Form, auch wenn die
         Sticky-Form absendet, die selbst kein Mengenfeld hat. */
      var qty = sel.packQty;
      if (!sel.subscribe) {
        var main = this.mainForm();
        var qtyInput = main && main.querySelector('input[name="quantity"]');
        if (qtyInput && Number(qtyInput.value) > 0) qty = qtyInput.value;
      }
      this.writeForm(form, sel, qty);
    }
  }

  customElements.define('purchase-options-supply', PurchaseOptionsSupply);
}
